import { useEffect, useState } from 'react';
import { removeAuth } from 'src/util/AuthModule';

const LOGOUT_TIME_VALUE = 3600 * 1000; // 60 minutes

const onLogout = () => {
  localStorage.clear();
  removeAuth();
};

export const useAutomaticLogout = () => {
  // Automatically log out and redirect to login screen in case of inactivity for 60 minutes

  const [lastActionTime, setLastActionTime] = useState(() => performance.now());

  useEffect(() => {
    if (import.meta.env.REACT_APP_API_ENV !== 'prod_gov') return;

    const timeout = setTimeout(onLogout, LOGOUT_TIME_VALUE);
    return () => clearTimeout(timeout);
  }, [lastActionTime]);

  useEffect(() => {
    if (import.meta.env.REACT_APP_API_ENV !== 'prod_gov') return;

    const userActionHandler = () => setLastActionTime(performance.now());

    window.addEventListener('mousemove', userActionHandler);
    window.addEventListener('keydown', userActionHandler);
    window.addEventListener('touchstart', userActionHandler);

    return () => {
      window.removeEventListener('mousemove', userActionHandler);
      window.removeEventListener('keydown', userActionHandler);
      window.removeEventListener('touchstart', userActionHandler);
    };
  }, []);
};
